import z__default from 'zod';
import { suretyQuoteUnderwritingStatusSchema, suretyQuoteStatusSchema } from '../../../../enums.mjs';
import { userId, agencyId, suretyAccountId, suretyQuoteId } from '../../../../types/opaque.mjs';
import { Underwriting } from '../../../../types/surety/quote/surety-quote.types.mjs';
import { Get } from '../../../sfaa-code/index.mjs';
import { Get as Get$1 } from '../../../surety/quote/surety-quote.dto.mjs';

var Quote;
(function (Quote) {
    (function (Underwriting$1) {
        Underwriting$1.schema = Underwriting.schema.and(z__default.object({
            status: suretyQuoteUnderwritingStatusSchema,
            stale: z__default.boolean(),
        }));
    })(Quote.Underwriting || (Quote.Underwriting = {}));
    (function (Get$2) {
        (function (Response) {
            const adminFields = {
                agencyId: agencyId,
                agentName: z__default.string().nullish(),
                agentId: userId.nullish(),
                reviewNote: z__default.string().optional(),
                underwriterUserId: userId,
                description: z__default.string().nullish(),
                sfaaCode: Get.Response.schema.nullable(),
            };
            Response.schema = z__default.discriminatedUnion("contractSuretyType", [
                Get$1.bidQuoteSchema.extend(Get$1.combinedStatus.shape).extend(adminFields),
                Get$1.finalQuoteSchema.extend(Get$1.combinedStatus.shape).extend(adminFields),
                Get$1.bidToFinalQuoteSchema.extend(Get$1.combinedStatus.shape).extend(adminFields),
            ]);
        })(Get$2.Response || (Get$2.Response = {}));
    })(Quote.Get || (Quote.Get = {}));
    (function (Create) {
        (function (Response) {
            Response.schema = z__default.object({
                id: suretyQuoteId,
                status: suretyQuoteStatusSchema,
                suretyAccountId,
            });
        })(Create.Response || (Create.Response = {}));
    })(Quote.Create || (Quote.Create = {}));
})(Quote || (Quote = {}));

export { Quote };
